import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const UploadIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M11.195 4.418a6 6 0 0 0-6.48 9.782 1 1 0 0 1-1.43 1.399A8 8 0 1 1 16.418 7H17.5a5.5 5.5 0 0 1 3.055 10.074 1 1 0 0 1-1.11-1.664A3.5 3.5 0 0 0 17.5 9h-1.79a1 1 0 0 1-.958-.714 6 6 0 0 0-3.557-3.868Z" />
    <path d="m13 14.414 2.293 2.293a1 1 0 0 0 1.414-1.414l-4-4a1 1 0 0 0-1.414 0l-4 4a1 1 0 1 0 1.414 1.414L11 14.414V21a1 1 0 1 0 2 0v-6.586Z" />
  </Icon>
));
export default UploadIcon;
